/* VH Become an Affiliate. PRESENTATION ONLY, next to the unchanged Alpine wizard (#affreg).
   READ-ONLY with respect to the wizard: it never writes Alpine state, never calls a wizard method, never touches the cart,
   never edits an element inside #affreg. What it does write:
     1. its own "Your order so far" card (rendered by sections/vh-affiliate.liquid), moved next to #affreg inside the
        wizard's section wrapper, i.e. OUTSIDE the Alpine component; filled from Alpine.$data(#affreg) (read only),
        re-read on Alpine.effect (read-only subscription) plus a MutationObserver fallback;
     2. its own <style id="vh-affiliate-dyn">: the "N products · NNN GV" line of each pack card (counts read from the
        pack's own "What's included" text in its <template>, GV from window.AFFREG_VOL_MAP) and the measured height
        of the store's sticky header (same measurement as VHK.top() in assets/vh-kit.js);
     3. a temporary <img> on <body> that flies a card photo into the summary on click (passive listener). */
(function () {
  'use strict';
  if (window.__vhAffiliate) return;
  window.__vhAffiliate = true;

  var root = document.getElementById('affreg');
  if (!root) return;
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var side = $('.vh-affiliate-side');
  var dyn = document.createElement('style');
  dyn.id = 'vh-affiliate-dyn';
  document.head.appendChild(dyn);
  var css = {top: '', packs: '', copy: '', sel: ''};
  var flush = function () { var t = css.top + css.copy + css.packs + css.sel; if (dyn.textContent !== t) dyn.textContent = t; };
  /* dyn rules are prefixed so they outrank vh-affiliate.css (which loads later, in <body>) */
  var P = 'html:root body ';
  var q = function (str) { return '"' + String(str).replace(/["\\]/g, '\\$&').replace(/\n/g, ' ') + '"'; };
  var copy = function (k, fb) { var el = $('.vh-affiliate-copy [data-k="' + k + '"]'); var t = el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; return t || fb; };
  /* MX$3,750 (the design's style) from the wizard's own price text "$ 3,750.00"; display only */
  var cur = function () { return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''; };
  var pretty = function (n) {
    if (!isFinite(n)) return '';
    var whole = Math.round(n * 100) % 100 === 0;
    return (cur() === 'MXN' ? 'MX$' : '$') + n.toLocaleString('en-US', {minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2});
  };
  var num = function (txt) { var m = String(txt || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/); return m ? parseFloat(m[0]) : NaN; };

  /* ---------- sticky header stack (copied from VHK.top, assets/vh-kit.js; read-only) ---------- */
  var topMax = 0, overlap = 0;
  function headerTop() {
    var m = 0;
    $$('#retail-reward-bar, .shopify-section-group-header-group, #referralBar, #replicatedInfo').forEach(function (el) {
      var s = getComputedStyle(el);
      if (s.position !== 'sticky' && s.position !== 'fixed') return;
      var gt = el.getBoundingClientRect().top, inner = el.offsetHeight < 400 ? el.offsetHeight : 0;
      $$(':scope > *, header, #referralBar, #replicatedInfo', el).forEach(function (c) {
        var r = c.getBoundingClientRect(), cs = getComputedStyle(c);
        if (r.height > 0 && r.height < 300 && cs.position !== 'fixed' && cs.visibility !== 'hidden') inner = Math.max(inner, r.bottom - gt);
      });
      m = Math.max(m, (parseFloat(s.top) || 0) + inner);
    });
    topMax = Math.max(topMax, Math.round(m));
    return topMax;
  }
  function measure() {
    var t = Math.min(headerTop(), 300), wrap = root.parentElement;
    /* if the store header overlays the page (absolute/fixed header), push the wizard down by the overlap.
       Measured only at the very top of the page: the lowest visible bar of the header vs the wizard's top.
       0 when the header is in the page flow (it is on this template today). */
    if ((window.scrollY || window.pageYOffset || 0) < 2) {
      var hb = 0;
      $$('#retail-reward-bar, .shopify-section-group-header-group header, #referralBar').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.height < 300 && getComputedStyle(el).visibility !== 'hidden') hb = Math.max(hb, r.bottom);
      });
      overlap = Math.max(0, Math.min(300, Math.round(hb - wrap.getBoundingClientRect().top)));
    }
    var prog = $('.affreg-progress', root), sideTop = 0;
    if (prog) {
      var pr = prog.getBoundingClientRect(), wr = wrap.getBoundingClientRect();
      sideTop = Math.round(pr.bottom - wr.top + (parseFloat(getComputedStyle(prog).marginBottom) || 0));
    }
    var progB = prog ? Math.round(prog.getBoundingClientRect().bottom - wrap.getBoundingClientRect().top) : 0;
    var sideH = side && !side.hidden ? side.offsetHeight : 0;
    css.top = '.affiliate-wizard-section{--vh-affiliate-top:' + t + 'px;--vh-affiliate-overlap:' + overlap + 'px' +
      (sideTop > 0 ? ';--vh-affiliate-sidetop:' + sideTop + 'px' : '') + (progB > 0 ? ';--vh-affiliate-progb:' + progB + 'px' : '') +
      (sideH > 0 ? ';--vh-affiliate-sideh:' + sideH + 'px' : '') + '}';
    flush();
  }

  /* ---------- pack cards: "N products · NNN GV" from data already on the page ---------- */
  function itemsOf(txt) { /* same parser as assets/vh-account.js itemsOf() */
    txt = String(txt || '');
    var tot = txt.match(/(?:Total Products|Quantity of Products)\s*:\s*(\d+)/i);
    var sum = 0, m, body = txt.split(/Total Products|Quantity of Products|Individual Products|FDA Disclaimer|Disclaimer:/i)[0];
    var start = body.search(/\(\d+\)/);
    if (start >= 0) { var re = /\((\d+)\)\s*([^,(]+?)\s*(?=,|\(|$)/g, seg = body.slice(start); while ((m = re.exec(seg))) sum += +m[1]; }
    return tot ? +tot[1] : sum;
  }
  function packLines() {
    var vol = window.AFFREG_VOL_MAP || {}, out = '', word = copy('products', 'products'), es = /^es/i.test(document.documentElement.lang || '');
    $$('.affreg-pack-card', root).forEach(function (card) {
      var id = card.getAttribute('data-pack-id');
      if (!id) return;
      var sel = P + '#affreg .affreg-pack-card[data-pack-id=' + q(id) + '] .affreg-pack-price';
      var tpl = $$('template[data-modal-for]', card).filter(function (t) { return t.getAttribute('data-modal-for') === id; })[0];
      var n = tpl ? itemsOf(tpl.content ? tpl.content.textContent : tpl.textContent) : 0;
      var v = vol[card.getAttribute('data-variant-id')], gv = v && v.gv ? Math.round(v.gv) : 0;
      var line = [n ? n + ' ' + word : '', gv ? gv + ' GV' : ''].filter(Boolean).join(' · ');
      if (line) out += sel + '::after{content:' + q(line) + '}';
      /* price in the design's format, only when there is no compare-at price to keep */
      var pe = $('.affreg-pack-price', card), pc = pe && $('.affreg-pack-price-compare', pe);
      if (pe && !pc) {
        var pr = pretty(num(pe.textContent));
        if (pr) out += sel + '{font-size:0;line-height:0}' + sel + '::before{content:' + q(pr) + ';display:block;font-size:16px;line-height:1.3}' + sel + '::after{font-size:12.5px}';
      } else if (pc) {
        /* compare-at kept (struck through, smaller) + the price, both in the same format as the other cards */
        var ps = pc.nextElementSibling, a = pretty(num(pc.textContent)), b = ps ? pretty(num(ps.textContent)) : '';
        if (a && b) out += sel + '{line-height:1.3}' + sel + ' > span{font-size:0}' +
          sel + ' > .affreg-pack-price-compare::before{content:' + q(a) + ';font-size:12.5px;font-weight:500;text-decoration:line-through;margin-right:6px}' +
          sel + ' > span:not(.affreg-pack-price-compare)::before{content:' + q(b) + ';font-size:16px}' + sel + '::after{font-size:12.5px}';
      }
      /* a pack whose name isn't its tier (Beauty Shot is a Basic pack): label it with its own name + the tier, e.g.
         "Beauty Shot (Basic)", so it isn't a second card called "Basic" (Bronson 2026-10-13) */
      var tt = card.getAttribute('data-pack-title') || '', tr = card.getAttribute('data-pack-tier') || '';
      if (tt && tr && tt.toLowerCase().indexOf(tr.toLowerCase()) !== 0) {
        var nm = tt.split(' (')[0].replace(/\s*Welcome Pack\s*$/i, '').trim();
        if (nm) out += P + '#affreg .affreg-pack-card[data-pack-tier]:not([data-pack-tier=""])[data-pack-id=' + q(id) + ']::before{content:' + q(nm + ' (' + tr + ')') + ';white-space:normal;line-height:1.15}';
      }
      if (card.getAttribute('data-includes-scanner') === 'true' && card.getAttribute('data-pack-tier'))
        out += P + '#affreg .affreg-pack-card[data-pack-tier]:not([data-pack-tier=""])[data-includes-scanner="true"][data-pack-id=' + q(id) + ']::before{content:attr(data-pack-tier) ' + q(' + ' + copy('scanner', es ? 'Escáner' : 'Scanner')) + '}';
    });
    css.packs = out;
    /* build-your-own card: the design's text over the block's own (which stays in the DOM for screen readers) */
    var c = P + '#affreg .affreg-custom-pack-cta';
    css.copy = c + '-content::before{content:' + q(copy('byo_kicker', 'Or build your own')) + '}' +
      c + '-heading,' + c + '-description{font-size:0!important;line-height:0}' +
      c + '-heading::after{content:' + q(copy('byo_title', '')) + ';display:block;font-size:clamp(20px,1.8vw,26px);line-height:1.15}' +
      c + '-description::after{content:' + q(copy('byo_text', '')) + ';display:block;font-size:14px;line-height:1.5}' +
      c + '::after{content:' + q(copy('byo_note', '')) + '}';
    if (!copy('byo_title', '') || !copy('byo_text', '')) css.copy = c + '-content::before{content:' + q(copy('byo_kicker', 'Or build your own')) + '}';
    flush();
  }

  /* ---------- "Your order so far" ---------- */
  var thumb = function (u) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=96' : ''; };
  function setRow(name, val, img) {
    var row = side && $('[data-row="' + name + '"]', side);
    if (!row) return;
    var on = val != null && val !== false;
    $('[data-empty]', row).hidden = on;
    var b = $('[data-val]', row); b.hidden = !on;
    if (on && typeof val === 'string' && b.textContent !== val) b.textContent = val;
    row.classList.toggle('is-empty', !on);
    var im = $('.vh-affiliate-ic img', row);
    if (im) {
      if (img && on) { if (im.getAttribute('src') !== img) im.setAttribute('src', img); im.hidden = false; } else im.hidden = true;
      row.classList.toggle('has-img', !!(img && on));
    }
  }
  function readState() {
    var d = null;
    try { d = window.Alpine && window.Alpine.$data ? window.Alpine.$data(root) : null; } catch (e) { d = null; }
    if (!d || !('currentStep' in d)) return null;
    var items = [];
    try { items = (d.cart && d.cart.items) ? Array.prototype.slice.call(d.cart.items) : []; } catch (e) { items = []; }
    return {step: Number(d.currentStep) || 0, country: d.country || '', sponsor: d.sponsor ? (d.sponsor.fullName || d.sponsor.slug || '') : '', items: items};
  }
  function render() {
    if (!side) return;
    var s = readState();
    if (!s) return;
    var show = s.step >= 1 && s.step <= 4;
    if (side.hidden === show) { side.hidden = !show; measure(); }
    if (!show) return;
    /* country: the wizard's own option label for its chosen code */
    var country = null;
    if (s.country && s.step >= 2) {
      var opt = $$('#affreg-country option', root).filter(function (o) { return o.value === s.country; })[0];
      var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      country = (opt ? opt.textContent.trim() : s.country) + (cur ? ' · ' + cur : '');
    }
    setRow('country', country);
    setRow('sponsor', s.sponsor && s.step >= 3 ? s.sponsor : null);
    /* pack: a cart line whose variant is one of the pack cards (or any line the wizard marks as a pack) */
    var cards = {};
    $$('.affreg-pack-card', root).forEach(function (c) { cards[c.getAttribute('data-variant-id')] = c; });
    var pack = null;
    s.items.forEach(function (it) {
      if (pack) return;
      var c = cards[String(it.variant_id)], props = it.properties || {};
      if (c) {
        var price = $('.affreg-pack-price', c), last = price && (price.lastElementChild || price);
        var tier = c.getAttribute('data-pack-tier') || '';
        var name = tier ? tier + (c.getAttribute('data-includes-scanner') === 'true' ? ' + ' + copy('scanner', 'Scanner') : '') : (c.getAttribute('data-pack-title') || '');
        var im = $('.affreg-pack-image', c);
        pack = {t: name + (last ? ' · ' + (pretty(num(last.textContent)) || last.textContent.trim()) : ''), img: im ? (im.currentSrc || im.src) : thumb(it.image), vid: String(it.variant_id)};
      } else if (props._bundle_pack || props._bbg_builder === '1') {
        pack = {t: (it.product_title || it.title || '') + ' · ' + pretty((it.final_line_price || 0) / 100), img: thumb(it.image)};
      }
    });
    setRow('pack', pack ? pack.t : null, pack && pack.img);
    /* the pack in the cart is outlined like the design's selected card */
    var selCss = pack && pack.vid ? P + '#affreg .affreg-pack-card[data-variant-id=' + q(pack.vid) + ']{border-color:#c9a46b;box-shadow:0 0 0 1px #c9a46b inset;background:rgba(201,164,107,.08)}' : '';
    if (selCss !== css.sel) { css.sel = selCss; flush(); }
    /* today's add-ons: the wizard's one-time add-on lines */
    var today = s.items.filter(function (it) { return it.properties && it.properties._wizard_addon === '1' && !it.selling_plan_allocation; });
    var tn = today.reduce(function (a, it) { return a + (it.quantity || 0); }, 0);
    var trow = $('[data-row="today"]', side);
    if (tn && trow) {
      $('[data-n]', trow).textContent = tn;
      $('[data-one]', trow).hidden = tn !== 1; $('[data-many]', trow).hidden = tn === 1;
      $('[data-total]', trow).textContent = pretty(today.reduce(function (a, it) { return a + (it.final_line_price || 0); }, 0) / 100);
    }
    setRow('today', tn ? true : null, today[0] && thumb(today[0].image));
    /* monthly autoship: the PV the wizard itself shows in its Step 4 bar (x-text="autoshipPV()") */
    var auto = s.items.filter(function (it) { return !!it.selling_plan_allocation; });
    var arow = $('[data-row="auto"]', side);
    if (auto.length && arow) {
      var blk = $$('.affreg-pv-block', root)[1], pvEl = blk && $('.affreg-pv-value strong', blk);
      var pv = pvEl ? parseInt(pvEl.textContent, 10) || 0 : 0;
      var goal = ((window.AFFREG_CONFIG || {}).autoshipPvGoal) || 50;
      $('[data-pv]', arow).textContent = pv;
      $('[data-ok]', arow).hidden = pv < goal;
      $('[data-togo]', arow).hidden = pv >= goal;
      $('[data-left]', arow).textContent = Math.max(0, goal - pv);
    }
    setRow('auto', auto.length ? true : null, auto[0] && thumb(auto[0].image));
    /* volumes: a mirror of what the wizard's own Step 4 bar shows (its x-text numbers, its :style track width,
       its visible x-show message). No business rule is computed here. */
    var vol = $('[data-vol]', side), bar = $('.affreg-pv-bar', root);
    if (vol && bar) {
      var blocks = $$('.affreg-pv-block', bar);
      var txt = function (blk) { return blk ? $$('.affreg-pv-value', blk).map(function (v) { return v.textContent.replace(/\s+/g, ' ').trim(); }).join(' · ') : ''; };
      var setT = function (sel, t) { var el = $(sel, vol); if (el && el.textContent !== t) el.textContent = t; };
      setT('[data-vo]', txt(blocks[0]));
      setT('[data-va]', txt(blocks[1]));
      var fill = $('.affreg-pv-progress-fill', bar), tr = $('[data-vt]', vol);
      if (fill && tr) {
        var wv = fill.style.width || '0%';
        if (tr.style.width !== wv) tr.style.width = wv;
        tr.classList.toggle('is-complete', fill.classList.contains('is-complete'));
      }
      var msg = $$('.affreg-pv-progress-text', bar).filter(function (p) { return p.style.display !== 'none' && !p.hasAttribute('x-cloak'); })[0];
      setT('[data-vmsg]', msg ? msg.textContent.replace(/\s+/g, ' ').trim() : '');
      var vshow = s.step === 4 || s.items.length > 0;
      if (vol.hidden === vshow) vol.hidden = !vshow;
    }
  }
  var raf = 0;
  var schedule = function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; try { render(); } catch (e) {} }); };

  function boot() {
    if (side && side.parentElement !== root.parentElement) root.parentElement.insertBefore(side, root.nextSibling);
    packLines();
    measure();
    var watched = false;
    if (window.Alpine && typeof window.Alpine.effect === 'function') {
      try {
        window.Alpine.effect(function () { /* read-only: touching the values subscribes; nothing is written */
          var s = readState();
          if (s) s.items.forEach(function (it) { return [it.variant_id, it.quantity, it.final_line_price, it.properties, it.selling_plan_allocation]; });
          schedule();
        });
        watched = true;
      } catch (e) { watched = false; }
    }
    /* fallback / extra signal: what the wizard renders (step x-show styles, x-text volumes) */
    if ('MutationObserver' in window) new MutationObserver(schedule).observe(root, {attributes: true, attributeFilter: ['style', 'class'], childList: true, characterData: true, subtree: true});
    if (!watched) setInterval(schedule, 1000);
    var cp = $('.vh-affiliate-copy');
    if (cp && 'MutationObserver' in window) new MutationObserver(function () { packLines(); }).observe(cp, {childList: true, characterData: true, subtree: true});
    schedule();
    setTimeout(measure, 1500);
    window.addEventListener('load', measure);
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { topMax = 0; measure(); }, 200); });
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () { measure(); });
      $$('#retail-reward-bar, .shopify-section-group-header-group').forEach(function (el) { ro.observe(el); });
      ro.observe($('.affreg-progress', root) || root);
      if (side) ro.observe(side);
    }
  }
  var booted = false;
  function tryBoot() {
    if (booted) return true;
    var d = null;
    try { d = window.Alpine && window.Alpine.$data ? window.Alpine.$data(root) : null; } catch (e) { d = null; }
    if (!d || !('currentStep' in d)) return false;
    booted = true; boot(); return true;
  }
  document.addEventListener('alpine:initialized', tryBoot);
  if (!tryBoot()) { var tries = 0, iv = setInterval(function () { if (tryBoot() || ++tries > 75) clearInterval(iv); }, 200); }

  /* ---------- "View details": what's included, with photos (2026-10-13) ----------
     The wizard's own list reads the card's 10 "Included product" settings, which are empty on every pack, so the popup
     showed a heading over nothing. Read the pack description instead ("(13) V-TEDETOX, (3) V-ITALAY, ...", the same
     parser as itemsOf) and draw a photo grid from snippets/vh-product-thumbs (names normalized like vh-packs). */
  (function () {
    var tj = document.getElementById('vh-aff-thumbs'), thumbs = {};
    try { thumbs = JSON.parse(tj ? tj.textContent : '{}'); } catch (e) { thumbs = {}; }
    var vhKey = function (s) { return String(s).toUpperCase().replace(/[^A-Z0-9+]/g, ''); };
    Object.keys(thumbs).forEach(function (k) { var nk = vhKey(k); if (!thumbs[nk]) thumbs[nk] = thumbs[k]; });
    var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };
    var vhName = function (n) { n = String(n).split(/\s+[\u2013\u2014-]\s+/)[0].trim(); var w = n.split(/\s+/), h = w.length / 2; if (w.length > 1 && w.length % 2 === 0 && w.slice(0, h).join(' ') === w.slice(h).join(' ')) n = w.slice(0, h).join(' '); if (typeof thumbs === 'object' && thumbs && typeof vhKey === 'function' && !thumbs[vhKey(n)]) { var ww = n.split(/\s+/); while (ww.length > 1 && !thumbs[vhKey(ww.join(' '))]) ww.pop(); if (thumbs[vhKey(ww.join(' '))]) n = ww.join(' '); } return n; };
    var entries = function (txt) {
      var body = String(txt || '').split(/Total Products|Quantity of Products|Individual Products|FDA Disclaimer|Disclaimer:/i)[0];
      var start = body.search(/\(\d+\)/), out = [], m;
      if (start < 0) { /* "Includes: 4x V-TEDETOX Spring – Supports ..." (Beauty Shot) */
        var re2 = /(\d+)\s*x\s+(.+?)\s+[\u2013\u2014-]\s/gi;
        while ((m = re2.exec(body))) { var n2 = vhName(m[2].trim()); if (n2) out.push([n2, +m[1]]); }
        return out;
      }
      var re = /\((\d+)\)\s*([^,(]+?)\s*(?=,|\(|$)/g, seg = body.slice(start);
      while ((m = re.exec(seg))) { var nm = vhName(m[2].replace(/[.:;]+$/, '').trim()); if (nm) out.push([nm, +m[1]]); }
      return out;
    };
    var fill = function (box) {
      if (box.hasAttribute('data-vh-incl')) return;
      box.setAttribute('data-vh-incl', '');
      if ($$('li', box).length) return; /* staff filled the card's own list: keep it */
      var modal = box.closest('.affreg-modal') || box.parentNode, desc = modal && $('.affreg-modal-pack-description', modal);
      var list = entries(desc ? desc.textContent : '');
      if (!list.length) { box.hidden = true; return; }
      var grid = document.createElement('div');
      grid.className = 'vh-aff-incl';
      grid.innerHTML = list.map(function (it) {
        var th = thumbs[vhKey(it[0])], name = th ? th[0] : it[0], img = th && th[1];
        return '<div class="vh-aff-incl-it"><span class="vh-aff-incl-q">×' + it[1] + '</span><span class="vh-aff-incl-ph">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span><b>' + esc(name) + '</b></div>';
      }).join('');
      var ul = $('ul', box); if (ul) ul.hidden = true;
      box.appendChild(grid);
    };
    var scan = function () { $$('.affreg-modal-pack-contents:not([data-vh-incl])').forEach(fill); };
    new MutationObserver(scan).observe(document.body, {childList: true, subtree: true});
    scan();
  })();

  /* ---------- fly a copy of the card photo into the summary (visual only) ---------- */
  if (!$('[data-vh-affiliate-fly]')) return;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var vis = function (r) { return r && r.width > 0 && r.height > 0; };
  var inView = function (el) { var r = el && el.getBoundingClientRect(); return vis(r) && r.bottom > 0 && r.top < (window.innerHeight || 0); };
  function fly(img, target) {
    if (!img || !target || (reduce && reduce.matches) || typeof img.animate !== 'function') return;
    var a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!vis(a) || !vis(b)) return;
    var c = document.createElement('img');
    c.src = img.currentSrc || img.src; c.alt = ''; c.setAttribute('aria-hidden', 'true'); c.className = 'vh-affiliate-flier';
    c.style.left = a.left + 'px'; c.style.top = a.top + 'px'; c.style.width = a.width + 'px'; c.style.height = a.height + 'px';
    document.body.appendChild(c);
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var dx = b.left + b.width / 2 - (a.left + a.width / 2);
    var dy = Math.min(Math.max(b.top + b.height / 2, 24), vh - 24) - (a.top + a.height / 2); /* off screen: nearest edge */
    var sc = Math.max(0.1, Math.min(1, 40 / Math.max(a.width, a.height)));
    var done = function () { if (c.parentNode) c.parentNode.removeChild(c); };
    try {
      var an = c.animate([
        {transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1},
        {transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sc + ') rotate(8deg)', opacity: 1, offset: 0.85},
        {transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + (sc * 0.6) + ') rotate(8deg)', opacity: 0}
      ], {duration: 820, easing: 'cubic-bezier(.65,0,.35,1)', fill: 'forwards'});
      an.onfinish = done; an.oncancel = done;
    } catch (err) { done(); return; }
    setTimeout(done, 1600);
  }
  var sideIc = function (row) { var r = side && !side.hidden && $('[data-row="' + row + '"] .vh-affiliate-ic', side); return inView(r) ? r : null; };
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var add = t.closest('#affreg .affreg-btn-addon');
    if (add) {
      var card = add.closest('.affreg-product-card'), sub = add.classList.contains('affreg-btn-addon-sub');
      var blocks = $$('#affreg .affreg-pv-block');
      var vb = side && !side.hidden && $('[data-vol]:not([hidden]) .vh-affiliate-vol-track', side);
      var wiz = sub ? blocks[1] : blocks[0], wr = wiz && wiz.getBoundingClientRect();
      fly(card && $('.affreg-product-image', card), sideIc(sub ? 'auto' : 'today') || (inView(vb) ? vb : null) || (wr && wr.width > 2 ? wiz : null));
      return;
    }
    var choose = t.closest('#affreg .affreg-pack-actions .affreg-btn-primary');
    if (choose) {
      var pack = choose.closest('.affreg-pack-card');
      fly(pack && $('.affreg-pack-image', pack), sideIc('pack') || $('#affreg .affreg-progress li:nth-child(3) .affreg-progress-num'));
    }
  }, {capture: true, passive: true}); /* capture: runs before the wizard's own @click (which disables the button and can switch steps); never blocks it */
})();
